export default __webpack_public_path__ + "static/media/400-bottles-of-beer.78e5a363.jpg";